<!-- commandcenter\src\app\page\home-page\home-page.component.html -->
<div class="page-container">
  <div class="page-header">
    <h1>Dashboard</h1>

    <app-borrower-kpi></app-borrower-kpi>
  </div>

  <div class="tables-container">
    <!-- Transaction Request Table -->
    <div class="table-section">
      <div class="table-header">
        <h2>Requests</h2>
      </div>

      <app-borrower-transaction-requests-table></app-borrower-transaction-requests-table>
    </div>

    <!-- Authorization Table -->
    <div class="table-section">
      <div class="table-header">
        <h2>Authorizations</h2>
      </div>

      <app-borrower-authorizations-table></app-borrower-authorizations-table>
    </div>

    <!-- Upcoming Transactions Table -->
    <div class="table-section">
      <div class="table-header">
        <h2>Open Transactions</h2>
      </div>

      <app-borrower-upcoming-transactions-table></app-borrower-upcoming-transactions-table>
    </div>

    <!-- Past Transactions Table -->
    <div class="table-section">
      <div class="table-header">
        <h2>Past Transactions</h2>
      </div>

      <app-borrower-past-transactions-table></app-borrower-past-transactions-table>
    </div>
  </div>

</div>